// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html, body {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

.container {
  width: 100%;
  text-align: center;
  background-color: transparent;
  border: none;
}

.image {
  display: block;
  margin: 0 auto;
  width: 25%;
  margin-bottom: 5%;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  border-radius: 20px 20px 0 0;
}

.header h1 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
}

.header2 {
  margin: 0 auto;
  max-width: 1000px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  border-radius: 20px 20px 0 0;
}

.header2 button {
  padding: 15px 20px;
  background-color: #99e2d0;
  color: black; 
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.header2 button:hover {
  background-color: #56c5b6;
}

.header2 h1 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
}

.header2 .logout-button {
  margin-left: auto;
  margin-top: 5px;
  margin-right: 5px;
}

.alertsContainer, .low-alert-container, .no-alert-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent; /* Color negro con 50% de transparencia */
  color: #000000;
  padding: 15px;
  border-radius: 0; /* Eliminamos el redondeo */
  margin-bottom: 20px;
}

.container-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
}

.alert {
  width: 95%;
  flex-grow: 1;
  margin: 10px 0;
  margin-right: 10px;
  padding: 10px;
  background-color: #f66969; /* Color negro con 50% de transparencia */
  border-left: 5px solid #e23232;
  border-radius: 5px;
}

.low-alert-container {
  background-color: transparent; /* Color negro con 50% de transparencia */
  color: #000000;
}

.low-alert {
  flex-grow: 1;
  margin: 10px 0;
  margin-right: 10px;
  padding: 10px;
  background-color: #fdcd67;
  border-left: 5px solid #f19a1f;
  border-radius: 5px;
}

.no-alert-container {
  background-color: transparent;
  color: #3c763d;
}


.menu {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
}

.menu button {
  padding: 15px;
  background-color: #b3e8e5;
  color: black; 
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease; 
  font-family: 'Monaco', monospace
}

.menu button:hover {
  background-color: #7fccd4;
}

.tips, .plantOfTheDay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5%;
  background-color: transparent;
  border: none;
  margin-bottom: 5%;
  width: 100%;
  box-sizing: border-box;
}


.plant-of-the-day-button {
  position: absolute;
  top: 10%; /* Ajusta este valor según la altura del header */
  left: 3%; /* Alineado a la izquierda con 20px de margen del borde izquierdo */
  cursor: pointer;
  width: 60px; /* Ajusta el tamaño según prefieras */
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 999;
}

.plant-of-the-day-button img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.hub img {
  width: 20%;
  height: auto;
  border-radius: 5px;
}

.prior {
  display: flex;
  gap: 5%; 
  min-height: 10vh;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
  align-items: center;
  box-sizing: border-box;
}

.prior button {
  text-align: center;
  font-size: clamp(0.5rem, 1.0vw, 0.7rem);
  background-color: #ff8a99;
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'Monaco', monospace;
  padding: 2vh;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  flex: 1 1;
}

.prior button:hover {
  transform: scale(1.05);
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.35);
}


.more button{
  font-size: 16px;
  background-color: #eca6c9;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-family: 'Monaco', monospace
}

.plantOfTheDay img {
  width: 20vh; 
  border-radius: 40px;
  object-fit: cover;
}

.hub {
  display: inline-block; 
  margin-right: 50px;
}

.general-container {
  display: flex;
  flex-direction: column;
}

.plant-image-container {
  flex: 1 1;
  text-align: left;
}

.plant-image {
  width: auto;
  height: 30vh;
  border-radius: 40px;
}

.custom-paragraph {
  margin-top: 1vh;
  margin-bottom: 1vh;
}

.pot-inside{
  height: 15vh;
  margin-right: 2%;
}

.data-container {
  flex: 4 1;
  padding-left: 20px;
}

.tittle-home {
  font-size: 300%;
	text-transform: uppercase;
  font-weight: bold;
}

.irrigate-select {
  margin-left: 10px;
}

.custom-days-input {
  width: 50px;
  margin-left: 10px;
}

.info-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #444;
  color: white;
  border: 1px solid #000000;
  padding: 20px;
  border-radius: 5px;
  z-index: 1000;
}

.info-popup-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}


.info-popup button {
  margin-top: 10px;
  padding: 5px 10px;
  background-color: #af4c4c;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.slick-list {
  width: 90%;
  height: 70vh;
  margin: auto;
}

.slick-slider {
  width: 90%;
  margin: 0% auto;
  overflow: visible;
}

.slick-slide > div {
  transform: scale(0.95);
}

.slick-dots {
  position: static;
  margin-top: 10px;
}

.custom-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  z-index: 2;
}

.custom-prev-arrow {
  left: -2%;
}

.custom-next-arrow {
  right: -2%;
}

.custom-arrow:hover {
  color: #7fccd4;
}

.gallery-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  width: 100%;
  margin: auto;
  margin-bottom: 5%;
  box-sizing: border-box;
}
.summary-panel {
  font-size: 24px;
  background-color: #333;
  color: #fff;
  min-height: 60vh;
  padding: 20px;
  border-radius: 8px;
  margin: 10px;
  overflow-x: auto;
}

.space-panel {
  border-bottom: 1px solid #555;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.space-name {
  font-size: 24px;
  margin-bottom: 10px;
}

.hubs-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px; 
  overflow-x: auto;
}

.hub-panel {
  background-color: #444;
  padding: 10px;
  border-radius: 4px;
}

.hub-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hub-name {
  font-weight: bold;
  color: #ccc;
}

.water-level {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.water-level img {
  width: 30px;
  height: 30px;
}

.minerals-level {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.minerals-level img {
  width: 47px;
  height: 30px;
}

.battery-level {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.battery-level img {
  width: 30px;
  height: 30px;
}



.error {
  color: #e74c3c;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #e74c3c;
  border-radius: 4px;
  margin-top: 10px;
}

.water-level-and-pots {
display: flex;
justify-content: space-between;
align-items: center;
}

.pots-list {
margin-left: 20px;
color: #ccc;
}

.pots-list li {
font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Home.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B,EAAE,yCAAyC;EACxE,cAAc;EACd,aAAa;EACb,gBAAgB,EAAE,2BAA2B;EAC7C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,yBAAyB,EAAE,yCAAyC;EACpE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B,EAAE,yCAAyC;EACxE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,sCAAsC;EACtC;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ,EAAE,iDAAiD;EAC3D,QAAQ,EAAE,mEAAmE;EAC7E,eAAe;EACf,WAAW,EAAE,qCAAqC;EAClD,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,8BAA8B;EAC9B,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,2CAA2C;EAC3C,qDAAqD;EACrD,SAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;;AAGA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;CAChB,yBAAyB;EACxB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;;AAIA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;AACA,aAAa;AACb,8BAA8B;AAC9B,mBAAmB;AACnB;;AAEA;AACA,iBAAiB;AACjB,WAAW;AACX;;AAEA;AACA,eAAe;AACf","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml, body {\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden;\n}\n\n.container {\n  width: 100%;\n  text-align: center;\n  background-color: transparent;\n  border: none;\n}\n\n.image {\n  display: block;\n  margin: 0 auto;\n  width: 25%;\n  margin-bottom: 5%;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  border-radius: 20px 20px 0 0;\n}\n\n.header h1 {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  margin: 0;\n}\n\n.header2 {\n  margin: 0 auto;\n  max-width: 1000px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  border-radius: 20px 20px 0 0;\n}\n\n.header2 button {\n  padding: 15px 20px;\n  background-color: #99e2d0;\n  color: black; \n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n}\n\n.header2 button:hover {\n  background-color: #56c5b6;\n}\n\n.header2 h1 {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  margin: 0;\n}\n\n.header2 .logout-button {\n  margin-left: auto;\n  margin-top: 5px;\n  margin-right: 5px;\n}\n\n.alertsContainer, .low-alert-container, .no-alert-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: transparent; /* Color negro con 50% de transparencia */\n  color: #000000;\n  padding: 15px;\n  border-radius: 0; /* Eliminamos el redondeo */\n  margin-bottom: 20px;\n}\n\n.container-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-grow: 1;\n}\n\n.alert {\n  width: 95%;\n  flex-grow: 1;\n  margin: 10px 0;\n  margin-right: 10px;\n  padding: 10px;\n  background-color: #f66969; /* Color negro con 50% de transparencia */\n  border-left: 5px solid #e23232;\n  border-radius: 5px;\n}\n\n.low-alert-container {\n  background-color: transparent; /* Color negro con 50% de transparencia */\n  color: #000000;\n}\n\n.low-alert {\n  flex-grow: 1;\n  margin: 10px 0;\n  margin-right: 10px;\n  padding: 10px;\n  background-color: #fdcd67;\n  border-left: 5px solid #f19a1f;\n  border-radius: 5px;\n}\n\n.no-alert-container {\n  background-color: transparent;\n  color: #3c763d;\n}\n\n\n.menu {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.menu button {\n  padding: 15px;\n  background-color: #b3e8e5;\n  color: black; \n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease; \n  font-family: 'Monaco', monospace\n}\n\n.menu button:hover {\n  background-color: #7fccd4;\n}\n\n.tips, .plantOfTheDay {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 5%;\n  background-color: transparent;\n  border: none;\n  margin-bottom: 5%;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n\n.plant-of-the-day-button {\n  position: absolute;\n  top: 10%; /* Ajusta este valor según la altura del header */\n  left: 3%; /* Alineado a la izquierda con 20px de margen del borde izquierdo */\n  cursor: pointer;\n  width: 60px; /* Ajusta el tamaño según prefieras */\n  height: 60px;\n  border-radius: 50%;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  z-index: 999;\n}\n\n.plant-of-the-day-button img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n\n.hub img {\n  width: 20%;\n  height: auto;\n  border-radius: 5px;\n}\n\n.prior {\n  display: flex;\n  gap: 5%; \n  min-height: 10vh;\n  justify-content: space-between;\n  width: 90%;\n  margin: 0 auto;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.prior button {\n  text-align: center;\n  font-size: clamp(0.5rem, 1.0vw, 0.7rem);\n  background-color: #ff8a99;\n  color: rgb(0, 0, 0);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-family: 'Monaco', monospace;\n  padding: 2vh;\n  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  flex: 1;\n}\n\n.prior button:hover {\n  transform: scale(1.05);\n  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.35);\n}\n\n\n.more button{\n  font-size: 16px;\n  background-color: #eca6c9;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-family: 'Monaco', monospace\n}\n\n.plantOfTheDay img {\n  width: 20vh; \n  border-radius: 40px;\n  object-fit: cover;\n}\n\n.hub {\n  display: inline-block; \n  margin-right: 50px;\n}\n\n.general-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.plant-image-container {\n  flex: 1;\n  text-align: left;\n}\n\n.plant-image {\n  width: auto;\n  height: 30vh;\n  border-radius: 40px;\n}\n\n.custom-paragraph {\n  margin-top: 1vh;\n  margin-bottom: 1vh;\n}\n\n.pot-inside{\n  height: 15vh;\n  margin-right: 2%;\n}\n\n.data-container {\n  flex: 4;\n  padding-left: 20px;\n}\n\n.tittle-home {\n  font-size: 300%;\n\ttext-transform: uppercase;\n  font-weight: bold;\n}\n\n.irrigate-select {\n  margin-left: 10px;\n}\n\n.custom-days-input {\n  width: 50px;\n  margin-left: 10px;\n}\n\n.info-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #444;\n  color: white;\n  border: 1px solid #000000;\n  padding: 20px;\n  border-radius: 5px;\n  z-index: 1000;\n}\n\n.info-popup-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n\n.info-popup button {\n  margin-top: 10px;\n  padding: 5px 10px;\n  background-color: #af4c4c;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.slick-list {\n  width: 90%;\n  height: 70vh;\n  margin: auto;\n}\n\n.slick-slider {\n  width: 90%;\n  margin: 0% auto;\n  overflow: visible;\n}\n\n.slick-slide > div {\n  transform: scale(0.95);\n}\n\n.slick-dots {\n  position: static;\n  margin-top: 10px;\n}\n\n.custom-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: transparent;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.custom-prev-arrow {\n  left: -2%;\n}\n\n.custom-next-arrow {\n  right: -2%;\n}\n\n.custom-arrow:hover {\n  color: #7fccd4;\n}\n\n.gallery-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n  width: 100%;\n  margin: auto;\n  margin-bottom: 5%;\n  box-sizing: border-box;\n}\n.summary-panel {\n  font-size: 24px;\n  background-color: #333;\n  color: #fff;\n  min-height: 60vh;\n  padding: 20px;\n  border-radius: 8px;\n  margin: 10px;\n  overflow-x: auto;\n}\n\n.space-panel {\n  border-bottom: 1px solid #555;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n\n.space-name {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.hubs-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px; \n  overflow-x: auto;\n}\n\n.hub-panel {\n  background-color: #444;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.hub-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.hub-name {\n  font-weight: bold;\n  color: #ccc;\n}\n\n.water-level {\n  font-size: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.water-level img {\n  width: 30px;\n  height: 30px;\n}\n\n.minerals-level {\n  font-size: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.minerals-level img {\n  width: 47px;\n  height: 30px;\n}\n\n.battery-level {\n  font-size: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.battery-level img {\n  width: 30px;\n  height: 30px;\n}\n\n\n\n.error {\n  color: #e74c3c;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #e74c3c;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.water-level-and-pots {\ndisplay: flex;\njustify-content: space-between;\nalign-items: center;\n}\n\n.pots-list {\nmargin-left: 20px;\ncolor: #ccc;\n}\n\n.pots-list li {\nfont-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
